export default function PHP_extends() {
  return (
    <div>
      <h1>PHP_extends</h1>
    </div>
  );
}
